var btnCobrand = {
  "btnCobrandDefault": {
    "background": "#43a34c",
    "&:hover": {
      "background": "#3c9144"
    },
    "&:active": {
      "background": "#347f3b"
    }
  },
  "btnCobrandDelta": {
    "background": "#036",
    "&:hover": {
      "background": "#00264d"
    },
    "&:active": {
      "background": "#001a33"
    }
  },
  "btnCobrandBonvoy": {
    "background": "#ff9662",
    "color": "#000",
    "&:hover": {
      "background": "#ff8549"
    },
    "&:active": {
      "background": "#ff742f"
    }
  },
  "btnCobrandBluesky": {
    "background": "#1790c5",
    "&:hover": {
      "background": "#147fae"
    },
    "&:active": {
      "background": "#126f97"
    }
  },
  "btnCobrandLowes": {
    "background": "#004890",
    "&:hover": {
      "background": "#003b77"
    },
    "&:active": {
      "background": "#002f5d"
    }
  },
  "btnCobrandHilton": {
    "background": "#104c97",
    "&:hover": {
      "background": "#0e4080"
    },
    "&:active": {
      "background": "#0b3569"
    }
  },
  "btnCobrandSchwab": {
    "background": "#00a3e0",
    "&:hover": {
      "background": "#0090c7"
    },
    "&:active": {
      "background": "#007ead"
    }
  },
  "btnCobrandPlenti": {
    "background": "#273691",
    "&:hover": {
      "background": "#222f7d"
    },
    "&:active": {
      "background": "#1c2769"
    }
  },
  "btnCobrandPlum": {
    "background": "#5a1326",
    "&:hover": {
      "background": "#450f1d"
    },
    "&:active": {
      "background": "#300a14"
    }
  },
  "btnCobrandAmazon": {
    "background": "#ff8f00",
    "color": "#000",
    "&:hover": {
      "background": "#e68100"
    },
    "&:active": {
      "background": "#cc7200"
    }
  }
};

export default btnCobrand;
